(function () {
	angular
		.module('trackeye')
		.factory('Device', _DeviceFactory);

	_DeviceFactory.$inject = ['SutMessage',
	 'SutMessageCollection',
	 'SutMessageService',
	 'TagService',
	 'Configuration',
	 'Features',
	 'LimitationService',
	 'FleetService',
	 'ImageService',
	 'Permissions',
	 'C4ApiService',
	 '$q'];

	function _DeviceFactory(SutMessage,
		 SutMessageCollection,
		 SutMessageService,
		 TagService,
		 Configuration,
		 Features,
		 LimitationService,
		 FleetService,
		 ImageService,
		 Permissions,
		 api,
		 $q) {

		/**
		 *
		 * @param {object} data
		 * @param {boolean} [mock]
		 * @constructor
		 */
		function Device(data, mock) {
			/**
			 * This is used to assert if the object is mock,
			 * it's only used upon initialization of the app
			 * to prevent dependencies failing.
			 */
			if (!angular.isDefined(mock)) {
				this.mock = false;
			} else {
				this.mock = mock;
			}

			this.id = data.id;
			this.guid = data.guid;
			this.active = data.active;
			this.name = data.name || "";
			this.description = data.description;
			this.nodeid = data.number;
			this.model = data.model;
			this.uap = data.uap;
			this.href = data.href;
			this.manualConfig = data.manualConfig;
			this.locale = data.locale;
			this.subscription = data.subscription;
			this.capacityRemaining = data.capacityRemaining;
			this.application = data.application || 0;

			this.resource = data;

			this.latest = SutMessageService.newSutMessage();
			this.selected = undefined;
			this.sutmessages = SutMessageService.newSutMessageCollection();

			this.features = new Features(this);
			this.limitation = LimitationService.instance();
			this.demoTo = data.demoTo ? new Date(data.demoTo) : false;

			this.echotags = [];

			this.readOnly = data.readOnly;
			this.prepaid = !!data.demoTo;

			this.replaceableBattery = undefined;
			this.batteryEpoch = undefined;
			this.batteryHysteresis = 50;

			this.configuration = new Configuration('te-unit-settings', 'Device configuration data');
			this.app_subscription = undefined; //@todo this should be a 'class'

			// @todo Find a prettier way to determine if the device is loading data
			this._working = false;

			// Associated fleet from /configurations
			this.fleet = undefined;

			this.temperature = undefined;
			this.humidity = undefined;

			// @todo only temporary
			this.loaded = false;
			this.postInitialized = false;

			this.imageSrc = undefined;

			this.callbacks = [];

			// @todo this needs refactoring...
			if (data.links) {
				var links = data.links;

				this.permissions = new Permissions(links.permissions);

				if (links.owner) {
					this.owner = links.owner.id;
				} else {
					this.owner = false;
				}

				if (links.configurations) {
					for (var i = 0; i < links.configurations.length; i++) {
						if (links.configurations[i].name === 'te-unit-settings') {
							this.configuration.populate(links.configurations[i]);
							this.setFleetAssociation();
							this.getTemperatureBoundary();
							break;
						}
					}
				}
			}
		}

		Device.prototype.isInitialized = function () {
			return this.postInitialized;
		};

		/**
		 * Asserts if the object is a mock.
		 * @returns {boolean}
		 */
		Device.prototype.isMock = function () {
			return this.mock;
		};

		Device.prototype.setFeatures = function(feature) {
			this.features.populate(feature);
		}

		Device.prototype.setLimitations = function() {
			LimitationService.get(this).then((function (data) {
				this.limitation.setDefinition(data);
			}).bind(this));
		}

		Device.prototype.setAppSubscription = function() {
			this.app_subscription = api.units().appSubscription({nodeid: this.getNodeId()});
		}

		/**
		 * Post initialization phase, of the device object. This is called
		 * from the device service, when a device is selected.
		 *
		 * @todo is this considered correct way, of post-initializing an object?
		 */
		Device.prototype.postInitialize = function () {
			var device = this,
				promises = [];

			if (this.postInitialized) {
				this._fire('postLoad');
				return true;
			}

			promises.push(
				api.local('GET', 'device/battery', {
					nodeid: device.getNodeId(),
					model: device.model
				}, {}, true, true).then(function (resp) {
					if (resp.data.activity)
						device.batteryEpoch = resp.data.activity.replaced;

					device.replaceableBattery = resp.data.replaceable;
				})
			);

			promises.push(
				TagService.fetch(device).then(function () {
					device.echotags = TagService.getEchotagsByUuid(device.getUuid());
				}, angular.noop)
			);

			$q.all(promises).finally(function () {
				device._fire('postLoad');
				device.postInitialized = true;
			});
		};

		/**
		 * Sets the name of the device
		 * @todo implement API call, to update device.
		 *
		 * @param {string} name
		 */
		Device.prototype.setName = function (name) {
			this.name = name;
		};

		/**
		 * Sets the device' to active
		 *
		 * @param {boolean} [state=true]
		 */
		Device.prototype.setActive = function (state) {
			this.active = state
		};

		/**
		 * Set the description of the device
		 *
		 * @param {string} text
		 */
		Device.prototype.setDescription = function (text) {
			this.description = text
		};

		/**
		 * Get c4api uuid of device
		 *
		 * @returns {string}
		 */
		Device.prototype.getUuid = function () {
			return this.id;
		};

		Device.prototype.setLocale = function (locale) {
			this.locale = locale;
		};

		Device.prototype.getLocale = function () {
			return this.locale;
		};

		/**
		 * Get guid of device
		 *
		 * @returns {string}
		 */
		Device.prototype.getGuid = function () {
			return this.guid;
		};

		/**
		 * Get the UAP version, of the device. This is not available
		 * on all devices.
		 *
		 * @returns {string}
		 */
		Device.prototype.getUap = function () {
			return this.uap;
		};

		Device.prototype.getHref = function () {
			return this.href;
		};

		/**
		 * Get the device name
		 *
		 * @returns {string}
		 */
		Device.prototype.getName = function () {
			return this.name || "";
		};

		/**
		 * Get the device name
		 *
		 * @returns {string}
		 */
		Device.prototype.getNameOrNodeId = function () {
			return this.name || this.getNodeId() || "";
		};

		Device.prototype.getSearchable = function (property, defaultValue) {
			if (defaultValue === undefined) {
				defaultValue = '';
			}

			return this[property] ? this[property].toString().toLowerCase() : defaultValue;
		}

		/**
		 * Get the device name
		 *
		 * @returns {string}
		 */
		Device.prototype.getDescription = function () {
			return this.description;
		};

		/**
		 * Get device nodeid
		 * @return {string}
		 */
		Device.prototype.getNodeId = function () {
			return this.nodeid || "";
		};

		Device.prototype.getModel = function () {
			return this.model;
		};

		Device.prototype.getApplication = function() {
			return this.application;
		}

		Device.prototype.registerBatteryReplacement = function (code) {
			return api.local('PUT', 'device/battery', {
				nodeid: this.nodeid,
				model: this.model,
				replacement_code: code
			});
		};

		Device.prototype.getTagById = function (number) {
			return this.echotags.find(function (tag) {
				return tag.getId() === number;
			});
		};

		/**
		 * Asserts if the device has a replaceable battery
		 *
		 * @returns {boolean}
		 */
		Device.prototype.hasReplaceableBattery = function () {
			return this.replaceableBattery;
		};

		Device.prototype.isBatteryReplaced = function () {
			return !!this.batteryEpoch;
		};

		Device.prototype.batteryReplacedDate = function () {
			return new Date(this.batteryEpoch * 1000);
		};

		Device.prototype.hasBatteryIndicator = function () {
			return this.features.useBatteryIcon() || this.sutmessages.hasConsumption();
		}

		Device.prototype.hasBatteryStateIndicator = function () {
			return this.features.useBatteryStateIcon();
		};

		/**
		 * Check if the battery is low, according to the given SutMessage
		 *
		 * @param {SutMessage} [message=SutMessage]
		 * @returns {boolean}
		 */
		Device.prototype.isBatteryLow = function (message) {
			var cap = message.getBatteryCapacity(),
				hystHigh = this.features.getBatteryLowValue();

			return cap <= hystHigh;
		};

		/**
		 * Check if the battery is medium, according to the given SutMessage
		 *
		 * @param {SutMessage} [message=SutMessage]
		 * @returns {boolean}
		 */
		Device.prototype.isBatteryMedium = function (message) {
			var cap = message.getBatteryCapacity(),
				hystHigh = this.features.getBatteryMediumValue(),
				hystLow = this.features.getBatteryLowValue();

			return (cap <= hystHigh && cap > hystLow);
		};

		/**
		 * Check if the battery is high, according to the given SutMessage
		 *
		 * @param {SutMessage} [message=SutMessage)
		 * @returns {boolean}
		 */
		Device.prototype.isBatteryHigh = function (message) {
			var cap = message.getBatteryCapacity(),
				hystLow = this.features.getBatteryMediumValue();

			return (cap > hystLow);
		};

		/**
		 * Returns measured distance for a given message, if no message
		 * is supplied, the method will use the latest.
		 *
		 * @param {SutMessage} [message]
		 * @returns {boolean|number}
		 */
		Device.prototype.getDistance = function (message) {
			if (!message)
				message = this.latest;

			var feat = this.features,
				ana = message.getAnaInput1();

			if (!ana)
				return false;

			return feat.calcDistance(ana);
		};

		/**
		 * Check if the battery is charging, according to the given SutMessage
		 *
		 * @param {SutMessage} [message=SutMessage)
		 * @returns {boolean}
		 */
		Device.prototype.isBatteryCharging = function (message) {
			return (message.getBatteryCapacity() > 4200)
		};

		Device.prototype.unsetTemperatureBoundary = function() {
			this.configuration.unset('id');
			this.configuration.unset('temp')
			this.configuration.save()
		}

		Device.prototype.setTemperatureBoundary = function (min, max) {
			this.temperature = {
				min: parseInt(min, 10),
				max: parseInt(max, 10)
			}
			// Setting id per unit. else Trackeye will not show temperature boundaries with color
			this.configuration.set('id', this.id);
			this.configuration.set('temp', this.temperature);
			this.configuration.save()
		};

		Device.prototype.getTemperatureBoundary = function() {
			var temp = this.configuration.get('id');
			var temp = this.configuration.get('temp');
			// console.log(temp);
			// console.log(`Device -> confGetTemp ${temp}`);
			if (temp) {
				this.temperature = {
					min: parseInt(temp.min, 10),
					max: parseInt(temp.max, 10)
				}
			}
		}

		Device.prototype.setFleetAssociation = function () {
			var fleet = this.configuration.get('fleet');
			if (fleet) {
				this.fleet = FleetService.getFleetByName(fleet);
			}
		};

		Device.prototype.getFleet = function () {
			return this.fleet || {};
		};

		Device.prototype.getImage = function () {
			if (this.imageSrc !== undefined)
				return this.imageSrc;

			var image_v1 = this.configuration.get('image'),
				_image 	= {
					uuid: this.configuration.get('imagev2.uuid'),
					ext: this.configuration.get('imagev2.ext'),
					src: undefined
				};

			if (!_image.uuid && !image_v1)
				return

			// imaged stored as base64, in configuration object.
			if (!_image.uuid && image_v1)
				return this.imageSrc = image_v1.src;

			if (_image.uuid) {
				ImageService.getImageDataURL(_image.uuid).then((function(image) {
					this.imageSrc = image;
				}).bind(this));
			}

			return this.imageSrc = "";
		};

		Device.prototype.setImage = function (uuid, ext) {
			this.imageSrc = undefined;
			this.configuration.unset('image'); // remove old image integration
			this.configuration.set('imagev2', {
				uuid: uuid,
				ext: ext
			});

			return this.configuration.save('/units/'+this.getUuid());
		};

		/**
		 * Assert if the temperature is higher than given parameter
		 *
		 * @param {number} [temp=22]
		 * @returns {boolean}
		 */
		Device.prototype.isTemperatureHigh = function (temp) {
			return this.temperature ? (this.temperature.max < parseInt(temp)) : false;
		};

		/**
		 * Assert if the temperature is lower than given parameter
		 *
		 * @param {number} temp
		 * @returns {boolean | null}
		 */
		Device.prototype.isTemperatureLow = function (temp) {
			return this.temperature ? (this.temperature.min > parseInt(temp)) : false;
		};

		/**
		 * Assert if the temperature is within the boundaries
		 *
		 * @param {number} [temp=22]
		 * @returns {boolean}
		 */
		Device.prototype.isTemperatureGood = function (temp) {
			return (this.isTemperatureHigh(temp) && this.isTemperatureLow(temp));
		};

		/**
		 * Assert if the Device has set any temperature boundaries
		 *
		 * @returns {boolean}
		 */
		Device.prototype.hasTemperatureBoundaries = function () {
			return !!this.temperature;
		};

		/**
		 * Sets a given message as selected.
		 * @param {SutMessage} message
		 */
		Device.prototype.setSelectedMessage = function (message) {
			this.selected = message;
		};

		Device.prototype.selectedOrLatest = function() {
			return this.selected || this.latest;
		}

		/**
		 * Default selected message is `this.latest`
		 *
		 * @returns {SutMessage}
		 */
		Device.prototype.getSelectedMessage = function () {
			return this.selected || this.latest;
		};

		Device.prototype.setInitialLatestMessage = function (data) {
			this.setLatestMessage(data)
			if (this.capacityRemaining !== undefined) {
				this.latest.setInitialBatCapacity(this.capacityRemaining)
			}
		}

		Device.prototype.setLatestMessage = function (data) {
			this.latest.populate(data, this.sutmessages.getCollectionId());
		};

		Device.prototype.updateLatestMessage = function (data) {
			var latest = this.latest;
			if (latest.isPopulated()) {
				var newLatest = new SutMessage(data, this.sutmessages.getCollectionId());

				// Assert if the message is newer
				if (newLatest.getTime() <= latest.getTime())
					return;

				latest.unsetInitialBatteryPercentage();
				this.updateLatestBatteryState(latest)

				this.sutmessages.postAddMore(latest, newLatest);
				this.latest = newLatest;
			} else {
				latest.populate(data, this.sutmessages.getCollectionId());
			}
		};

		Device.prototype.setSearchScore = function(score) {
			this._score = score;
		}

		Device.prototype.getSearchScore = function() {
			return this._score;
		}

		/**
		 * Used for time / relevance sorting
		 */
		Device.prototype.getTimescore = function(ts) {
			if (!ts) {
				return false;
			}

			return this.latest.getTime() / ts;
		};

		/**
		 * Used for sorting battery
		 */
		Device.prototype.getBatteryscore = function() {
			var score = 10;
			if (this.features.useBatteryIcon()) {
				score = 0;
				if (this.isBatteryHigh(this.latest)) {
					score += 3
				} else if (this.isBatteryMedium(this.latest)) {
					score += 2
				} else {
					score += 1
				}
			} else {
				if (this.latest.hasCapacityPercentage()) {
					score += this.latest.getBatteryPercentage(0);
				} else if (this.latest.hasInitialBatteryPercentage()) {
					score += this.latest.getInitialBatteryPercentage(0);
				}
			}
			return score;
		};

		Device.prototype.updateLatestBatteryState = function (message) {
			var deferred = $q.defer();

			if (!this.features.isCapture() && this.features.useBatteryIcon() && !message.hasCapacity()) {
				api.sutmessages().single({
					id: this.id,
					fsid: message.id.split("/")[0],
					msgid: message.id.split("/")[1]
				}, function (resp) {
					message.cap = resp.cap;
					deferred.resolve();
				});
			} else {
				deferred.resolve();
			}

			return deferred.promise;
		};

		Device.prototype.isOwner = function (id) {
			return this.owner === id;
		};

		Device.prototype.hasOwner = function () {
			return !!this.owner;
		};

		/**
		 * Check if the device has any sutmessages
		 *
		 * @return {boolean}
		 */
		Device.prototype.hasMessages = function () {
			return !!this.sutmessages.count();
		};

		Device.prototype.isLoaded = function () {
			return this.loaded;
		};

		Device.prototype.searchMessages = function (begin, end) {
			var deferred = $q.defer();

			api.sutmessages().get({
				id: this.nodeid,
				begin: begin,
				end: end
			}, function (resp) {
				var messages = new SutMessageCollection();
				messages.addMany(resp.reverse());
				deferred.resolve(messages);
			}, function() {
				deferred.reject()
			});

			return deferred.promise;
		};

		Device.prototype.getLatestOrCurrentTs = function () {
			return this.latest.getServerTs() || (new Date()).toISOString();
		};

		/**
		 * Loads sutmessages for the device, which will update
		 * the sutmessage collection of the device
		 * @returns {void}
		 */
		Device.prototype.loadMessages = function () {
			this.working(true);

			SutMessageService.loadMessages(this, this.getLatestOrCurrentTs()).then((function (messages) {
				this.working(false);
				this.sutmessages.addMany(messages, this.latest);
				this._fire('sutLoad', this.getLatestGoodMessage());
				this.loaded = true;
			}).bind(this), console.error);
		};

		Device.prototype.requestTimeout = function () {
			return SutMessageService.hasTimeout(this.getUuid());
		};

		Device.prototype.loadMoreMessages = function () {
			if (this.working())
				return;

			this.working(true);
			SutMessageService.loadMessages(this, this.sutmessages.last().getTs()).then((function (messages) {
				this._fire('sutLoad', this.getLatestGoodMessage());
				this.sutmessages.addMany(messages);
				this.working(false)
			}).bind(this), (function () {
				this.working(false)
			}).bind(this));

			//this._loadMessagesIterator(this.sutmessages.last().getTs(), 12, 20);
		};

		Device.prototype.deselect = function () {
			this._cancelEvent('sutLoad');
			this.sutmessages.cancelAddressQueue();
			this.setSelectedMessage(this.latest);
		};

		/**
		 * @param {string} name
		 * @param {Function} cb
		 * @param {string} [ident]
		 */
		Device.prototype.on = function (name, cb, ident) {
			var evt = this._hasEvent(name);
			if (!evt) {
				this.callbacks.push({
					"name": name,
					"fn": [cb],
					"idents": !!ident ? [ident] : []
				});
			} else {
				if (evt.fired) {
					cb(evt.data);
				}

				if (!evt.fn.length) {
					evt.fn = [cb];
				} else {
					if (!ident) {
						evt.fn.push(cb);
					} else {
						if (evt.idents.indexOf(ident) == -1) {
							evt.fn.push(cb);
						}
					}
				}
			}
		};

		/**
		 *
		 * @param {string} name
		 * @param {*} [data]
		 * @private
		 */
		Device.prototype._fire = function (name, data) {
			var evt = this._hasEvent(name);

			if (!evt) {
				evt = {
					name: name,
					fn: [],
					fired: true,
					idents: []
				};
				this.callbacks.push(evt);
			} else {
				evt.fired = true;

				if (evt.fn.length) {
					for (var i = 0; i < evt.fn.length; i++) {
						var cb = evt.fn[i];

						if (!cb)
							continue;
						cb(data);
					}
				}
			}
		};

		Device.prototype._hasEvent = function (name) {
			return this.callbacks.find(function (evt) {
				return (evt.name === name);
			});
		};

		Device.prototype._cancelEvent = function (name) {
			this.callbacks = this.callbacks.filter(function (evt) {
				if (evt.name !== name)
					return true;

				return evt.fired;
			});
		};

		Device.prototype.isSutDevice = function () {
			return !!parseInt(this.features.sut_protocol);
		};

		Device.prototype.isPrepaid = function () {
			return this.prepaid && this.hasOwner();
		};

		/**
		 * Get subscription id, this is unrelated to `appSubscription`
		 */
		Device.prototype.getSubscription = function () {
			return this.subscription;
		};

		/**
		 * Asserts if the device have had a subscription plan,
		 * or if this is the first
		 */
		Device.prototype.hasAppSubscription = function () {
			return !!(this.app_subscription && this.app_subscription.ts);
		};

		/**
		 * Asserts if the device has a manual configuretion
		 * @returns {boolean}
		 */
		Device.prototype.hasManualConfig = function () {
			return !!this.manualConfig;
		};

		/**
		 * Fetches the latest sutmessage with a valid position
		 * @returns {SutMessage}
		 */
		Device.prototype.getLatestGoodMessage = function () {
			return this.sutmessages.all().find(function (message) {
				return message.hasLonLat();
			}) || this.latest;
		};

		/**
		 * Setter/getter for the working state of the device.
		 * @param {boolean} [value]
		 * @returns {boolean}
		 */
		Device.prototype.working = function (value) {
			if (value === undefined)
				return this._working;

			return this._working = value;
		};

		/**
		 * Asserts if the device is expired
		 *
		 * @returns {boolean}
		 */
		Device.prototype.isExpired = function () {
			if (!this.demoTo)
				return false;

			return new Date(this.demoTo).getTime() < new Date().getTime();
		};

		/**
		 * Asserts if the device is active
		 *
		 * @returns {boolean}
		 */
		Device.prototype.isActive = function () {
			return this.active;
		};

		/**
		 * @todo needs own class object
		 *
		 * @returns {boolean}
		 */
		Device.prototype.isRecurring = function () {
			return !!this.app_subscription.recurring;
		};

		/**
		 * Asserts if the device is in read-only mode
		 *
		 * @returns {boolean}
		 */
		Device.prototype.isReadonly = function () {
			return !!this.readOnly;
		};

		/**
		 * @todo debugging
		 *
		 * @returns {Object}
		 */
		Device.prototype.getPlain = function () {
			return this.resource.toJSON();
		};

		return Device;
	}
})();
